import { render, staticRenderFns } from "./EventCard.vue?vue&type=template&id=3c0812c8&scoped=true"
import script from "./EventCard.vue?vue&type=script&lang=ts"
export * from "./EventCard.vue?vue&type=script&lang=ts"
import style0 from "./EventCard.vue?vue&type=style&index=0&id=3c0812c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c0812c8",
  null
  
)

export default component.exports